import { useEffect, useState } from 'react';
import { api } from '../../services/api.ts';

interface PresenceResponse {
  online: number;
}

export function LiveCounter() {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    let timeout: ReturnType<typeof setTimeout>;

    const tick = async () => {
      try {
        const r = await api<PresenceResponse>('/presence', { raw: false }).catch(() => null);
        if (cancelled) return;
        if (r) setCount(r.online);
      } catch {
        // endpoint not yet implemented — leave null
      }
      if (!cancelled) timeout = setTimeout(tick, 5000);
    };
    void tick();
    return () => {
      cancelled = true;
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div
      style={{
        marginTop: 12,
        fontFamily: 'var(--f-mono)',
        fontSize: 13,
        color: 'var(--c-fg-dim)',
        letterSpacing: '0.08em',
      }}
    >
      {count == null ? '— in arena' : <><span style={{ color: 'var(--c-acid)' }}>{count.toLocaleString()}</span> in arena</>}
    </div>
  );
}
